import React from 'react';
import WizardStep from '../WizardStep';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SuccessStepProps {
  merchantCenterCount: number;
  feedCount: number;
  onFinish: () => void;
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  merchantCenterCount,
  feedCount,
  onFinish,
}) => {
  return (
    <WizardStep title="You're all set!" hideNext hideBack>
      <div className="flex flex-col items-center text-center space-y-4 py-2">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="w-7 h-7 text-primary" />
        </div>

        <p className="text-sm text-muted-foreground">
          {merchantCenterCount} Merchant Center{merchantCenterCount !== 1 ? 's' : ''} and{' '}
          {feedCount} feed{feedCount !== 1 ? 's' : ''} synced successfully.
        </p>

        <Button onClick={onFinish} className="min-w-[180px]">
          Get Started
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </WizardStep>
  );
};

export default SuccessStep;
